"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        description: 'Data is received by Trunkrs',
        id: 1,
        name: 'DATA_RECEIVED',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'Shipment data is processed and ready for shipment',
        id: 2,
        name: 'DATA_PROCESSED',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment is sorted in the Central Hub',
        id: 4,
        name: 'SHIPMENT_SORTED',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment was not scanned at the Central Hub and therefore deemed not arrived',
        id: 29,
        name: 'EXCEPTION_SHIPMENT_NOT_ARRIVED',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment is sorted at the sub depot into the right cart',
        id: 6,
        name: 'SHIPMENT_SORTED_AT_SUB_DEPOT',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment was scanned at the wrong sub depot',
        id: 31,
        name: 'EXCEPTION_SHIPMENT_MIS_SORTED',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment is currently missing. An investigation is required.',
        id: 33,
        name: 'EXCEPTION_SHIPMENT_MISSING',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment is accepted by the driver',
        id: 7,
        name: 'SHIPMENT_ACCEPTED_BY_DRIVER',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment was declined by the driver',
        id: 32,
        name: 'EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment is delivered correctly',
        id: 8,
        name: 'SHIPMENT_DELIVERED',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment is delivered to a neighbor',
        id: 9,
        name: 'SHIPMENT_DELIVERED_TO_NEIGHBOR',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment could not be delivered',
        id: 10,
        name: 'SHIPMENT_NOT_DELIVERED',
        type: "SHIPMENT" /* SHIPMENT */,
    },
    {
        description: 'The shipment has been post poned to a new date',
        id: 23,
        name: 'CHANGE_SHIPMENT_POST_PONED',
        type: "CHANGE" /* CHANGE */,
    },
    {
        description: 'The shipment was cancelled by the sender',
        id: 38,
        name: 'EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment was camcelled by Trunkrs',
        id: 39,
        name: 'EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS',
        type: "EXCEPTION" /* EXCEPTION */,
    },
    {
        description: 'The shipment has been sent return to sender',
        id: 42,
        name: 'RETURN_SHIPMENT_TO_SENDER',
        type: "RETURN_TO_SENDER" /* RETURN_TO_SENDER */,
    },
];
